import { useLayoutEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'

import {
  selectIsCookiesUser,
  selectUUID,
  selectUserCountryCode,
} from 'root-redux/selects/user'

import { useCookieConsentAnswer } from 'hooks/useCookieConsentAnswer'

export const useApplovinPixelInitialization = (): void => {
  const uuid = useSelector(selectUUID)
  const userCountryCode = useSelector(selectUserCountryCode)
  const isCookiesUser = useSelector(selectIsCookiesUser)

  const { hasAdvertizingAndMarketingCookie } = useCookieConsentAnswer()

  const shouldAxonPixelBePaused = useMemo(
    () => isCookiesUser && !hasAdvertizingAndMarketingCookie,
    [isCookiesUser, hasAdvertizingAndMarketingCookie],
  )

  useLayoutEffect(() => {
    if (!uuid || !userCountryCode || shouldAxonPixelBePaused) {
      return
    }

    const axonScript = document.createElement('script')

    axonScript.type = 'text/javascript'
    axonScript.text = `
    var AXON_EVENT_KEY="dc525b02-028f-4f27-9d34-c0fe313ffe63";
    !function(e,r){var
    t=["https://s.axon.ai/pixel.js","https://c.albss.com/p/l/loader.iife.js"];if(!e
    .axon){var
    a=e.axon=function(){a.performOperation?a.performOperation.apply(a,arguments):a.
    operationQueue.push(arguments)};a.operationQueue=[],a.ts=Date.now(),a.eventKey=
    AXON_EVENT_KEY;for(var
    n=r.getElementsByTagName("script")[0],o=0;o<t.length;o++){var
    i=r.createElement("script");i.async=!0,i.src=t[o],n.parentNode.insertBefore(i,n
    )}}}(window,document);
    axon('track', 'page_view')
    `
    document.body.appendChild(axonScript)
  }, [shouldAxonPixelBePaused, userCountryCode, uuid])
}
